export default __webpack_public_path__ + "static/media/formationPage.9812ff8a.jpg";